// Kompakter App-Header mit Wordmark oben rechts. Klickbar → führt zur Landing.
// Plus „Meine Umfragen"-Link, der zum lokalen Admin-Dashboard führt — wird nur
// gezeigt, wenn der User im Browser bereits eine Umfrage angelegt hat.

import { listSurveys } from '../admin-store';
import { el } from './dom';

export function renderAppHeader(): HTMLElement {
  const links = el('nav', { class: 'app-header-nav' });
  if (listSurveys().length > 0) {
    links.append(
      el('a', { class: 'app-header-link', href: '/admin' }, '📋 Meine Umfragen'),
    );
  }
  const wordmark = el('a', { class: 'app-wordmark', href: '/', 'aria-label': 'Slot — zur Startseite' },
    el('span', { class: 'app-wordmark-pixel hue-yes' }),
    el('span', { class: 'app-wordmark-pixel hue-maybe' }),
    el('span', { class: 'app-wordmark-pixel hue-no' }),
    el('span', { class: 'app-wordmark-pixel hue-ink' }),
    el('span', { class: 'app-wordmark-text' }, 'Slot'),
    el('span', { class: 'app-wordmark-domain' }, 'gotyou.at'),
  );
  return el('header', { class: 'app-header' }, links, wordmark);
}
